import { Typography, Container, Theme, Button, Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlineOutlined';

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    height: '100vh',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    background: theme.palette.background.default,
    paddingTop: theme.spacing(8),
  },
  content: {
    textAlign: 'center',
    padding: theme.spacing(4),
  },
  icon: {
    fontSize: '80px',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
    animation: '$bounce 2s infinite',
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 'bold',
  },
  subtitle: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
  buttonContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'center',
  },
  '@keyframes bounce': {
    '0%, 100%': {
      transform: 'translateY(0)',
    },
    '50%': {
      transform: 'translateY(-20px)',
    },
  },
}));

const PageNotFound = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  return (
    <Box className={classes.root}>
      <Container maxWidth="sm">
        <Box className={classes.content}>
          <ErrorOutlineIcon className={classes.icon} />
          <Typography
            variant="h3"
            className={classes.title}
            color="primary"
          >
            Page Not Found
          </Typography>
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{
              marginBottom: "16px"
            }}
          >
            The page you're looking for doesn't exist or has been moved.
          </Typography>
          <Box className={classes.buttonContainer}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => navigate(-1)}
            >
              Go Back
            </Button>
            <Button
              variant="outlined"
              color="primary"
              size="large"
              onClick={() => navigate('/')}
            >
              Go Home
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default PageNotFound;
